import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import api from '../../services/api';

const AppAuthorized = ({ app, children }) => {
  const [isAuthorized, setIsAuthorized] = useState(null);

  const { data: userApps, isLoading } = useQuery({
    queryKey: ['userApps'],
    queryFn: async () => {
      const response = await api.get('/appmodule/user-apps');
      return response.data;
    },
  });

  useEffect(() => {
    if (userApps) {
      const hasAccess = userApps.some(userApp => userApp.id === app);
      setIsAuthorized(hasAccess);
    }
  }, [userApps, app]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Verifying access...</p>
        </div>
      </div>
    );
  }

  if (isAuthorized === false) {
    return <Navigate to="/app-select" replace />;
  }

  if (isAuthorized === true) {
    return <>{children}</>;
  }

  return null;
};

export default AppAuthorized;